import { CommonModule } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
    selector: 'basket-overview-skeleton',
    imports: [CommonModule, SkeletonModule],
    templateUrl: './basket-overview-skeleton.component.html',
    styleUrl: './basket-overview-skeleton.component.scss',
})
export class BasketOverviewSkeletonComponent {
    public readonly isMobile: InputSignal<boolean> = input(false);
    // Number of supplier placeholder cards to render while the basket loads.
    public readonly supplierCount: InputSignal<number> = input(1);

    protected get supplierPlaceholders(): number[] {
        return Array.from({ length: Math.max(1, this.supplierCount()) }, (_, index) => index);
    }
}
